module.exports = {"410922100":"城关镇","410922101":"马庄桥镇","410922102":"瓦屋头镇","410922103":"仙庄镇","410922104":"柳格镇","410922105":"韩村镇","410922106":"固城镇","410922107":"阳邵镇","410922200":"六塔乡","410922202":"巩营乡","410922203":"马村乡","410922204":"高堡乡","410922205":"古城乡","410922206":"大流乡","410922208":"大屯乡","410922212":"双庙乡","410922213":"纸房乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410922.json
// module id = 1731
// module chunks = 0